import type { VoidFunctionComponent } from 'react';
import { Category } from '../../../../../shared/issuesV2';
import VulnerabilityIssueDetailContent from '../FullPageIssueDetails/VulnerabilityIssueDetailContent';
import LicensingIssueDetailContent from '../FullPageIssueDetails/LicensingIssueDetailContent';
import QualityIssueDetailContent from '../FullPageIssueDetails/QualityIssueDetailContent';

type Props = {
  category: Category;
};

/**
 * Displays the content of the issue tab base on the category.
 */
const IssueDetailsV2IssueTab: VoidFunctionComponent<Props> = ({ category }) => {
  switch (category) {
    case Category.Vulnerability:
      return <VulnerabilityIssueDetailContent />;
    case Category.Licensing:
      return <LicensingIssueDetailContent />;
    case Category.Quality:
      return <QualityIssueDetailContent />;
    default:
      return null;
  }
};

export default IssueDetailsV2IssueTab;
